import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { QuillEditorService } from '@zaoblako/web/core/services/quill-editor.service';
import { Editor, EditorModule } from 'primeng/editor';

@Component({
  standalone: true,
  selector: 'crm-editor',
  templateUrl: './editor.component.html',
  styleUrls: ['./editor.component.scss'],
  imports: [CommonModule, EditorModule, FormsModule],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EditorComponent implements OnInit {
  @ViewChild('editor') public editor: Editor;

  @Input() public value: string;
  @Output() public valueChange = new EventEmitter<string>();

  @Output() public onPaste = new EventEmitter<ClipboardEvent>();
  @Output() public onTextChange = new EventEmitter<any>();

  public _height: string;

  @Input() public height = '200px';
  @Input() public heightInMobile = '110px';
  @Input() public disabled = false;
  @Input() public styleClass: string;

  public editorModules: any;

  public constructor(private readonly quillEditorService: QuillEditorService) {
    this.editorModules = quillEditorService.modules;
  }

  public ngOnInit() {
    this.checkIsMobile(window.innerWidth);
  }

  @HostListener('window:resize', ['$event'])
  public onResize(event: Event) {
    this.checkIsMobile((event.target as Window).innerWidth);
  }

  private checkIsMobile(innerWidth: number) {
    if (innerWidth < 576) {
      this._height = this.heightInMobile;
    } else {
      this._height = this.height;
    }
  }
}
